"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchInput = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
// eslint-disable-next-line import/prefer-default-export
exports.StyledSearchInput = (0, styled_components_1.default)(ui_components_1.SearchInput) `
  max-width: ${({ theme }) => theme.spacing(70)};

  p {
    text-transform: capitalize;
  }

  // override MUI styles for input
  .MuiInputBase-root {
    padding: ${({ theme }) => theme.spacing(2)} !important;
  }
`;
